import React, { memo, useCallback } from 'react';
import './toolbar.scss';
import { CourseBuilderService } from '@business/services';
import { TextBlockVariation } from '@modules/course/CourseBuilder/Blocks/TextBlock';
import { ImageBlockVariation } from '@modules/course/CourseBuilder/Blocks/ImageBlock';
import { MultimediaBlockVariation } from '@modules/course/CourseBuilder/Blocks/MultimediaBlock';
import { DividerBlockVariation } from '@modules/course/CourseBuilder/Blocks/DividerBlock';
import { openAddCourseBuilderWidgetOverlay } from '../AddWidgetOverlay';
import { ListBlockVariation } from '@modules/course/CourseBuilder/Blocks/ListBlock';
import { CourseBuilder } from '@modules/course/CourseBuilder/Blocks/types';

export interface PageBottomToolbarProps {
  onAdd(type: CourseBuilder.BlockType, variation: string, at?: number): void;
  size: number;
  at?: number;
}

export const PageBottomToolbar = memo((props: PageBottomToolbarProps) => {
  const { size, at } = props;

  const onAdd = useCallback(
    (category: CourseBuilder.BlockCategory, variation?: string) => {
      switch (category) {
        case CourseBuilder.BlockCategory.text:
          return props.onAdd(CourseBuilder.BlockType.text, TextBlockVariation.paragraphWithHeading, at);
        case CourseBuilder.BlockCategory.image:
          return props.onAdd(CourseBuilder.BlockType.image, ImageBlockVariation.imageCentered, at);
        case CourseBuilder.BlockCategory.multimedia:
          return props.onAdd(CourseBuilder.BlockType.multimedia, MultimediaBlockVariation.video, at);
        case CourseBuilder.BlockCategory.list:
          return props.onAdd(CourseBuilder.BlockType.list, ListBlockVariation.numberedList, at);
        case CourseBuilder.BlockCategory.divider:
          return props.onAdd(CourseBuilder.BlockType.divider, DividerBlockVariation.divider, at);
      }
    },
    [at, props],
  );

  return (
    <div className="proposal-bottom-toolbar" style={{ paddingTop: 30, paddingBottom: 30 }}>
      <div className="bottom-all-blocks" onClick={() => openAddCourseBuilderWidgetOverlay({ onAdd: props.onAdd, at })}>
        <i className="fa fa-th"></i>
        <span>All Blocks</span>
      </div>
      <div className="bottom-block-list">
        {CourseBuilderService.allBlockCategories(true).map(category => (
          <div key={category} className="block-tookbar-item" onClick={() => onAdd(category)}>
            <i className={CourseBuilder.CategoryIcon[category]}></i>
            <span>{category === CourseBuilder.BlockCategory.multimedia ? 'Video' : category}</span>
          </div>
        ))}
      </div>
    </div>
  );
});
